/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Resource_Integrate_DescriptionInputs */

const en_blog_resource_integrate_description = /** @type {(inputs: Blog_Resource_Integrate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the API, MCP, and AI agent surfaces that are available or planned.`)
};

const zh_blog_resource_integrate_description = /** @type {(inputs: Blog_Resource_Integrate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看当前可用或正在规划的 API、MCP 和 AI Agent 入口。`)
};

/**
* | output |
* | --- |
* | "Check the API, MCP, and AI agent surfaces that are available or planned." |
*
* @param {Blog_Resource_Integrate_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_resource_integrate_description = /** @type {((inputs?: Blog_Resource_Integrate_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Resource_Integrate_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_resource_integrate_description(inputs)
	return zh_blog_resource_integrate_description(inputs)
});
export { blog_resource_integrate_description as "blog.resource_integrate_description" }